import emojiRegex from 'emoji-regex';
import { z } from 'zod';

const emojisRegex = emojiRegex().toString();
const singleEmoji = `^(${emojisRegex.slice(1, emojisRegex.length - 2)})(\uFE0E|\uFE0F)?$`;
const regex = new RegExp(singleEmoji);

export const ZodOneEmoji = z
  .string()
  .refine((value) => regex.test(value), 'must be a single emoji');
